import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'admin: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required',
  );
}

// Capture the auth flow type from the URL hash BEFORE supabase-js detects the
// session and rewrites the URL. Only `recovery` surfaces as PASSWORD_RECOVERY
// in supabase-js v2 — invites fire a regular SIGNED_IN, so the consumer of
// this value (auth.tsx) needs the original `type` to route invitees to
// /set-password.
//
// One-shot: must be consumed via consumeInitialAuthFlowType() so subsequent
// log-out/log-in cycles in the same page session don't re-trigger setup.
function readInitialAuthFlowType(): 'invite' | 'recovery' | null {
  if (typeof window === 'undefined') return null;
  const hash = window.location.hash;
  if (!hash) return null;
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const type = params.get('type');
  if (type === 'invite' || type === 'signup') return 'invite';
  if (type === 'recovery') return 'recovery';
  return null;
}

let _initialAuthFlowType: 'invite' | 'recovery' | null = readInitialAuthFlowType();

export function consumeInitialAuthFlowType(): 'invite' | 'recovery' | null {
  const v = _initialAuthFlowType;
  _initialAuthFlowType = null;
  return v;
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'neoseum-admin-auth',
  },
});

export const BOOKING_API_URL =
  import.meta.env.VITE_BOOKING_API_URL ?? `${url}/functions/v1`;
